export default {
    methods:{
        randomRange: function(min,max){
            return Math.round(Math.random()* (+max - +min) + min);
        }
    }
}